export class GoogleAddressPredictionModel {
  address: string;
  placeId: string;

  constructor(model: any = null) {
    this.address = model?.description;
    this.placeId = model?.place_id;
  }
}
